/**
 * Storage Keys
 * Centralized constants for localStorage keys used across the app
 */

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'glide_path_access_token',
  REFRESH_TOKEN: 'glide_path_refresh_token',
  USER: 'glide_path_user',
} as const;
